import { store } from '../store'
import DynamicModuleRegistrationUtil from '../utils/dynamicModuleRegistration'
import { WarehouseReceivingOrdersEnum, WarehouseReceivingOrderEnum } from '../enums/modules/routes'

import { ModuleName } from '@/store/modules/createWarehouseReceivingOrder'
import { MerchantPermissions } from '@/rbac'

const WarehouseReceivingOrder = () =>
  import(/* webpackChunkName: "WarehouseReceivingOrder" */ '@/components/warehouseReceivingOrder/warehouseReceivingOrder')

// Vuex Modules to load
const WarehouseReceivingOrdersModule = () => import(/* webpackChunkName: "WarehouseReceivingOrders" */ '../store/modules/warehouseReceivingOrders')
const CreateWarehouseReceivingOrdersModule = () => import(/* webpackChunkName: "WarehouseReceivingOrders" */ '../store/modules/createWarehouseReceivingOrder')

// Components
const WarehouseReceivingOrdersPlaceholder = () =>
  import(/* webpackChunkName: "WarehouseReceivingOrders" */ '@/components/warehouseReceivingOrders/WarehouseReceivingOrdersPlaceholder')

const WarehouseReceivingOrderPlaceholder = () =>
  import(/* webpackChunkName: "WarehouseReceivingOrder" */ '@/components/warehouseReceivingOrder/warehouseReceivingOrderPlaceholder')

const WarehouseReceivingOrders = () =>
  import(/* webpackChunkName: "WarehouseReceivingOrders" */ '@/components/warehouseReceivingOrders/warehouseReceivingOrders')

const CreateWro = () =>
  import(/* webpackChunkName: "WarehouseReceivingOrders" */ '@/components/createWarehouseReceivingOrder/CreateWro')

const CreateWroPlaceholder = () =>
  import(/* webpackChunkName: "WarehouseReceivingOrders" */ '@/components/createWarehouseReceivingOrder/CreateWroPlaceholder')

const UpdateDraftWroPlaceholder = () =>
  import(/* webpackChunkName: "WarehouseReceivingOrders" */ '@/components/createWarehouseReceivingOrder/UpdateDraftWroPlaceholder')

const CreateWroModal = () =>
  import(/* webpackChunkName: "WarehouseReceivingOrders" */ '@/components/createWarehouseReceivingOrder/CreateWroConfirmationModal')

const ChooseWroType = () =>
  import(/* webpackChunkName: "WarehouseReceivingOrders" */ '@/components/createWarehouseReceivingOrder/ChooseWroType')

const DownloadBoxLabels = () =>
  import(/* webpackChunkName: "DownloadBoxLabels" */ '@/components/warehouseReceivingOrder/DownloadBoxLabels')

const CancelWroModal = () =>
  import(/* webpackChunkName: "WarehouseReceivingOrders" */ '@/components/warehouseReceivingOrder/modals/CancelWro')

const dynamicModuleRegistrationWarehouseReceivingOrdersArgs = () => {
  return {
    modulesNamespace: store._modulesNamespaceMap,
    moduleName: 'warehouseReceivingOrders',
    module: WarehouseReceivingOrdersModule,
    store,
    modulePath: 'warehouseReceivingOrders'
  }
}

const dynamicModuleRegistrationCreateWarehouseReceivingOrderArgs = () => {
  return {
    modulesNamespace: store._modulesNamespaceMap,
    moduleName: ModuleName,
    module: CreateWarehouseReceivingOrdersModule,
    store,
    modulePath: ModuleName
  }
}

export const editWroAllowedResolver = async (to, _from = null, next = () => {}) => {
  const isWroEditAllowed = store.getters.VueEditWROEnabledFeatureFlag
  if (isWroEditAllowed) next()
}

export default [
  {
    path: '/inventory/receiving',
    component: WarehouseReceivingOrdersPlaceholder,
    name: WarehouseReceivingOrdersEnum.WarehouseReceivingOrders,
    beforeEnter (_to, _from, next) {
      DynamicModuleRegistrationUtil(dynamicModuleRegistrationWarehouseReceivingOrdersArgs()).then(
        () => next()
      )
    },
    meta: { domain: WarehouseReceivingOrdersEnum.WarehouseReceivingOrders },
    children: [
      {
        path: 'choose-wro-type',
        component: ChooseWroType,
        name: WarehouseReceivingOrderEnum.ChooseWarehouseReceivingOrderType,
        beforeEnter (_to, _from, next) {
          // Permanently route to the new page
          DynamicModuleRegistrationUtil(dynamicModuleRegistrationCreateWarehouseReceivingOrderArgs()).then(() => next({ path: '/inventory/receiving/send/' }))
        },
        meta: { showSideNav: true }
      },
      {
        path: 'send',
        component: CreateWroPlaceholder,
        name: WarehouseReceivingOrderEnum.CreateWarehouseReceivingOrderPlaceholder,
        beforeEnter (_to, _from, next) {
          if (!MerchantPermissions.can('manage', 'wro_create')) {
            next({ path: '/inventory/receiving/all' })
          } else {
            DynamicModuleRegistrationUtil(dynamicModuleRegistrationCreateWarehouseReceivingOrderArgs()).then(() => next())
          }
        },
        meta: { showSideNav: false },
        children: [
          {
            path: ':draftId',
            component: UpdateDraftWroPlaceholder,
            name: WarehouseReceivingOrderEnum.UpdateDraftWroPlaceholder,
            meta: { showSideNav: false },
            children: [
              {
                path: 'create-wro',
                component: CreateWroModal,
                name: WarehouseReceivingOrderEnum.CreateWroConfirmation,
                meta: { showSideNav: false }
              },
              {
                path: '/',
                component: CreateWro,
                name: WarehouseReceivingOrderEnum.CreateWarehouseReceivingOrder,
                meta: { showSideNav: true }
              }
            ]
          },
          {
            path: '/',
            component: CreateWro,
            name: WarehouseReceivingOrderEnum.CreateWarehouseReceivingOrder,
            meta: { showSideNav: true }
          }
        ]
      },
      {
        path: ':wroId/summary',
        component: WarehouseReceivingOrderPlaceholder,
        name: WarehouseReceivingOrderEnum.WarehouseReceivingOrderPlaceholder,
        props: (route) => ({
          wroId: parseInt(route.params.wroId)
        }),
        beforeEnter (_to, _from, next) {
          DynamicModuleRegistrationUtil(dynamicModuleRegistrationWarehouseReceivingOrdersArgs()).then(() => next())
        },
        children: [
          {
            path: '/',
            component: WarehouseReceivingOrder,
            name: WarehouseReceivingOrderEnum.WarehouseReceivingOrder,
            meta: { showSideNav: true },
            props: (route) => ({
              wroId: parseInt(route.params.wroId)
            })
          }
        ]
      },
      {
        path: ':wroId/edit',
        component: UpdateDraftWroPlaceholder,
        name: WarehouseReceivingOrderEnum.CreateWarehouseReceivingOrder,
        meta: { showSideNav: false },
        children: [
          {
            path: 'edit-wro',
            component: CreateWroModal,
            name: WarehouseReceivingOrderEnum.EditWroConfirmation,
            meta: { showSideNav: false }
          },
          {
            path: '/',
            component: CreateWro,
            name: WarehouseReceivingOrderEnum.EditWro,
            meta: { showSideNav: true },
            props: (route) => ({
              wroId: parseInt(route.params.wroId)
            }),
            beforeEnter (_to, _from, next) {
              DynamicModuleRegistrationUtil(dynamicModuleRegistrationCreateWarehouseReceivingOrderArgs()).then(
                async () => {
                  await editWroAllowedResolver(_to, _from, next)
                }
              )
            }
          }
        ]
      },
      {
        path: ':wroId/cancel-wro',
        component: CancelWroModal,
        name: WarehouseReceivingOrderEnum.CancelWro,
        meta: { showSideNav: false }
      },
      {
        path: ':wroId/download-box-labels',
        component: DownloadBoxLabels,
        name: WarehouseReceivingOrderEnum.DownloadBoxLabels,
        meta: { showSideNav: false }
      },
      {
        path: ':view',
        component: WarehouseReceivingOrders,
        name: WarehouseReceivingOrdersEnum.WarehouseReceivingOrders,
        meta: { showSideNav: true }
      },
      {
        path: ':view/show-returns',
        redirect: ':view'
      }
    ]
  }
]
